<template>
  <div class="overflow-hidden carousel-aside-info-block"
       :class="{'carousel-aside-info-block_overlay': wider_carousel}">
    <div class="container carousel_aside_info">
      <div class="row carousel_aside_info_row">
        <div class="col-sm-4 col-12 carousel-aside-info-block__carousel">
          <swiper
            :swiper_config="swiper_config"
            :swiper_events="swiper_events"
            next_btn_class="image_next_btn"
            prev_btn_class="image_prev_btn"
            add_navigation_buttons>
            <swiper-slide
              v-for="(slide, index) in slides"
              :class="{active_init_slide: !active_slide_index && !index}"
              :key="`swiper-slide_${index}_${uid}`">
              <lazy-image
                class="h-100"
                :src="slide.image_src"
                cover_img
                img_border_radius
                :lazy_src="slide.image_lazy_src"
                :alt="`main-slide_${index}`"/>
            </swiper-slide>
          </swiper>
        </div>
        <div class="col-12 carousel_aside_info-slide"
             :class="wider_carousel ? 'col-sm-6' : 'col-sm-4'">
          <div v-if="get_active_slide"
               class="carousel_aside_info-slide__inner">
            <div class="carousel_aside_info-slide__inner-text">
              <default-title
                class="carousel-aside-info-block__title"
                :title="get_active_slide.title"
                title_tag="div"
              />
              <div
                v-if="get_active_slide.sub_title"
                class="carousel-aside-info-block__sub-title">
                {{get_active_slide.sub_title}}
              </div>
              <yellow-icon
                v-if="get_active_slide.icon"
                class="mt-40 mt-xs-20"
                :icon="get_active_slide.icon"
              />
              <html-block
                class="mt-20 mt-xs-10"
                :content="get_active_slide.content"
              />
              <div
                v-if="get_active_slide.btn_link && get_active_slide.btn_text"
                :class="{'text-center': getIsMobile}"
                class="mt-40 mt-xs-20">
                <default-button
                  :href="get_active_slide.btn_link">
                  {{get_active_slide.btn_text}}
                </default-button>
              </div>
            </div>
            <div class="position-relative carousel_aside_info-slide__range-block">
              <div class="carousel_aside_info-slide__inner-range">
                <div class="carousel_aside_info-slide__inner-range-slide">
                  <div class="carousel_aside_info-slide__inner-range-slide_active"
                       :style="{width: `${range_slide_width}%`}"
                  />
                </div>
                <div class="carousel_aside_info-slide__inner-range_counter">
                  {{active_slide_counter}}/{{slides.length}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import YellowIcon from "../small_parts/YellowIcon.vue";
import LazyImage from "../small_parts/LazyImage.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import {mapGetters} from "vuex";
import Swiper from "../modules/Swiper/Swiper.vue";
import uid_mixin from "../../mixins/uid_mixin";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";
import DefaultButton from "../slots/DefaultButton.vue";

export default {
  name: "CarouselWithAsideInfoBlock",
  mixins: [uid_mixin],
  components: {
    DefaultButton,
    HtmlBlock,
    DefaultTitle,
    Swiper,
    SwiperSlide,
    LazyImage,
    YellowIcon
  },
  props: {
    /**props**/
    wider_carousel: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    slides: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        image_src: {
          type: String,
          required: true,
          admin_type: 'image',
        },
        image_lazy_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        sub_title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        icon: {
          type: String,
          default: '',
          admin_type: 'select',
          admin_data_values: [
            'going_up.svg',
            'light_bulb.svg',
            'line.svg',
            'star.svg',
            'puzzle.svg',
            'target.svg',
            'earth.svg',
            'bag.svg',
            'hand_shake.svg',
            'flag.svg',
            'diagram.svg'
          ],
        },
        content: {
          type: String,
          default: '',
          admin_type: 'editor',
        },
        btn_text: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        btn_link: {
          type: String,
          default: '',
          admin_type: 'input',
        },
      }
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    get_active_slide() {
      return this.slides[this.active_slide_index] || this.slides[0]
    },
    swiper_config() {
      return {
        speed: 750,
      }
    },
    swiper_events() {
      return {
        realIndexChange: this.slideChanged,
      }
    },
    active_slide_counter() {
      return this.active_slide_index+1
    },
    range_slide_width() {
      return this.active_slide_counter/this.slides.length * 100
    }
  },
  data() {
    return {
      active_slide_index: 0,
    }
  },
  methods: {
    slideChanged({realIndex = 0}) {
      if (this.active_slide_index === realIndex) return
      this.active_slide_index = realIndex
    }
  }
}
</script>
